import { render, staticRenderFns } from "./FailedTransactions.vue?vue&type=template&id=74f016db&scoped=true"
import script from "./FailedTransactions.vue?vue&type=script&lang=js"
export * from "./FailedTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f016db",
  null
  
)

export default component.exports